import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAppSelector } from "./store/hooks";
import { selectIsLoggedIn } from "./features/user/user.selector";
import { selectUserProfile } from "./features/user/user.selector";
import { selectExtension } from "./features/extension/extension.selector";

function PrivateRoute() {
  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  const location = useLocation();
  const navigate = useNavigate();
  const user = useAppSelector(selectUserProfile);
  const { isExtension } = useAppSelector(selectExtension);
  const onboardingState = user?.onboardingState;
  const subscriptionState = user?.subscriptionState;

  useEffect(() => {
    const handleSubscriptionExpired = () => {
      if (!location.pathname.startsWith("/choose-plan")) {
        navigate("/choose-plan", { replace: true });
      }
    };
    window.addEventListener("subscription-expired", handleSubscriptionExpired);
    return () => window.removeEventListener("subscription-expired", handleSubscriptionExpired);
  }, [location.pathname, navigate]);

  useEffect(() => {
    if (!isLoggedIn) return;

    if (
      !isExtension &&
      (onboardingState === "pending_plan" ||
        subscriptionState === "inactive") &&
      !location.pathname.startsWith("/choose-plan") &&
      !location.pathname.includes("payment-success")
    ) {
      navigate("/choose-plan", { replace: true });
      return;
    }

    if (
      !isExtension &&
      (subscriptionState === "past_due" || subscriptionState === "unpaid") &&
      !location.pathname.startsWith("/account/billing") &&
      !location.pathname.includes("payment-success")
    ) {
      navigate("/account/billing", { replace: true });
    }
  }, [
    isLoggedIn,
    location.pathname,
    onboardingState,
    subscriptionState,
    isExtension,
    navigate,
  ]);

  if (
    isExtension &&
    isLoggedIn &&
    (onboardingState === "pending_plan" ||
      subscriptionState === "past_due" ||
      subscriptionState === "unpaid" ||
      subscriptionState === "inactive")
  ) {
    return <Navigate to="/extension-action-required" replace />;
  }

  return isLoggedIn ? <Outlet /> : <Navigate to="/login" />;
}

export default PrivateRoute;
